export default __webpack_public_path__ + "static/media/jason-goodman-X8H8vPcelPk-unsplash.aa372967.jpg";